import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { Box } from '../ui';
import type { TextProps } from '../ui/Text/Text';
import { color, position, space, typography } from 'styled-system';

export const Tip = styled.div({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  minWidth: 0,
});

export const Text = styled.span<TextProps>(
  {
    maxWidth: '100%',
    overflow: 'hidden',
  },
  color,
  position,
  space,
  typography,
);

export const VoyageBoxDataContainer = styled<FunctionComponent>(Box)`
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  &:last-child {
    flex-grow: 1;
  }

  & + &:before {
    content: '|';
    color: ${(props) => props.theme.colors.neutral.black_700};
    margin: 0 ${(props) => props.theme.space[2]}px 0 0;
  }
`;

export const UnselectableDiv = styled.div`
  & * {
    user-select: none;
  }
`;

export const SidebarContainer = styled.div`
  border-right: 1px solid #556883;
  justify-content: flex-end;
  background-color: #d5dce5;
  flex-direction: column;
  align-items: center;
  margin-top: 56px;
  display: flex;
  flex: 1;
`;
